// Automatically generated during build - DO NOT EDIT MANUALLY
export const APP_VERSION = {
  "version": "1.0.0",
  "buildCode": "20261104.1851",
  "buildDate": "04-Nov-2026 06:51 PM",
  "gitCommit": "eb3c32c",
  "gitBranch": "master",
  "timestamp": 1793798472772,
  "appName": "OxyLoans Web"
};

export default APP_VERSION;
